const setSelectedSpot = set => selectedSpot => set(state => {
  return {
    ...state,
    selectedSpot
  };
}, false, 'SET_SELECTED_SPOT');

export default setSelectedSpot;
